export const globalVueInstanceVariableName = "__app__";
